import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaBalancos from '../../components/balanco/listar';


function BalancosScreen () {
    return (
        <Fragment>
            <Head titulo="Balanços do Município de Macuco"/>
            <Header />
            <Container>
                <ListaBalancos />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default BalancosScreen;